"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandyShopAuction = exports.fetchAuctionHistory = exports.fetchAuctionBidByWalletAddress = exports.fetchAuctionsByShopAddress = void 0;
const backend_1 = require("./factory/backend");
const config_1 = __importDefault(require("./vendor/config"));
const vendor_1 = require("./vendor");
const program_1 = require("./factory/program");
const shipping_1 = require("./vendor/shipping");
function fetchAuctionsByShopAddress(shopId, queryDto) {
    return (0, backend_1.fetchAuctionsByShop)(config_1.default, shopId, queryDto);
}
exports.fetchAuctionsByShopAddress = fetchAuctionsByShopAddress;
function fetchAuctionBidByWalletAddress(auctionAddress, walletAddress) {
    return (0, backend_1.fetchAuctionBid)(config_1.default, auctionAddress, walletAddress);
}
exports.fetchAuctionBidByWalletAddress = fetchAuctionBidByWalletAddress;
function fetchAuctionHistory(auctionAddress, auctionBidQuery) {
    return (0, backend_1.fetchAuctionHistoryByAddress)(config_1.default, auctionAddress, auctionBidQuery);
}
exports.fetchAuctionHistory = fetchAuctionHistory;
class CandyShopAuction {
    static async buyNow(params) {
        const { tokenAccount, tokenMint, wallet, shopAddress, candyShopProgramId, shopTreasuryMint, shopCreatorAddress, connection, env, version } = params;
        const program = await (0, vendor_1.getProgram)(connection, candyShopProgramId, wallet);
        const [auction, auctionBump] = await (0, vendor_1.getAuction)(shopAddress, tokenMint, candyShopProgramId);
        const [auctionHouseAuthority] = await (0, vendor_1.getAuctionHouseAuthority)(shopCreatorAddress, shopTreasuryMint, candyShopProgramId);
        const [auctionHouse] = await (0, vendor_1.getAuctionHouse)(auctionHouseAuthority, shopTreasuryMint);
        const [feeAccount] = await (0, vendor_1.getAuctionHouseFeeAcct)(auctionHouse);
        const [treasuryAccount] = await (0, vendor_1.getAuctionHouseTreasuryAcct)(auctionHouse);
        const [metadata] = await (0, vendor_1.getMetadataAccount)(tokenMint);
        const buyNowParams = {
            auction,
            auctionBump,
            authority: auctionHouseAuthority,
            candyShop: shopAddress,
            buyer: wallet,
            treasuryMint: shopTreasuryMint,
            nftMint: tokenMint,
            metadata,
            auctionHouse,
            feeAccount,
            treasuryAccount,
            program,
            env: env
        };
        const txHash = await (0, shipping_1.supply)(buyNowParams, version, program_1.buyNowAuctionV1, program_1.buyNowAuction);
        return txHash;
    }
    static async bid(params) {
        const { tokenAccount, tokenMint, wallet, shopAddress, candyShopProgramId, shopTreasuryMint, shopCreatorAddress, connection, version, bidPrice } = params;
        const program = await (0, vendor_1.getProgram)(connection, candyShopProgramId, wallet);
        const [auction] = await (0, vendor_1.getAuction)(shopAddress, tokenMint, candyShopProgramId);
        const auctionAccount = await program.provider.connection.getAccountInfo(auction);
        if (!auctionAccount) {
            throw new Error(vendor_1.CandyShopErrorType.AuctionDoesNotExist);
        }
        const [auctionHouseAuthority] = await (0, vendor_1.getAuctionHouseAuthority)(shopCreatorAddress, shopTreasuryMint, candyShopProgramId);
        const [auctionHouse] = await (0, vendor_1.getAuctionHouse)(auctionHouseAuthority, shopTreasuryMint);
        const [feeAccount] = await (0, vendor_1.getAuctionHouseFeeAcct)(auctionHouse);
        const [metadata] = await (0, vendor_1.getMetadataAccount)(tokenMint);
        const bidParams = {
            auction,
            authority: auctionHouseAuthority,
            candyShop: shopAddress,
            buyer: wallet,
            treasuryMint: shopTreasuryMint,
            nftMint: tokenMint,
            metadata,
            auctionHouse,
            feeAccount,
            bidPrice,
            program
        };
        const txHash = await (0, shipping_1.supply)(bidParams, version, program_1.bidAuctionV1, program_1.bidAuction);
        return txHash;
    }
    static async withdrawBid(params) {
        const { tokenAccount, tokenMint, wallet, shopAddress, candyShopProgramId, shopTreasuryMint, shopCreatorAddress, connection, version } = params;
        const program = await (0, vendor_1.getProgram)(connection, candyShopProgramId, wallet);
        const [auction] = await (0, vendor_1.getAuction)(shopAddress, tokenMint, candyShopProgramId);
        const auctionAccount = await program.provider.connection.getAccountInfo(auction);
        if (!auctionAccount) {
            throw new Error(vendor_1.CandyShopErrorType.AuctionDoesNotExist);
        }
        const [auctionHouseAuthority] = await (0, vendor_1.getAuctionHouseAuthority)(shopCreatorAddress, shopTreasuryMint, candyShopProgramId);
        const [auctionHouse] = await (0, vendor_1.getAuctionHouse)(auctionHouseAuthority, shopTreasuryMint);
        const [feeAccount] = await (0, vendor_1.getAuctionHouseFeeAcct)(auctionHouse);
        const [metadata] = await (0, vendor_1.getMetadataAccount)(tokenMint);
        const withdrawBidParams = {
            auction,
            authority: auctionHouseAuthority,
            candyShop: shopAddress,
            buyer: wallet,
            treasuryMint: shopTreasuryMint,
            nftMint: tokenMint,
            metadata,
            auctionHouse,
            feeAccount,
            program
        };
        const txHash = await (0, shipping_1.supply)(withdrawBidParams, version, program_1.withdrawBidV1, program_1.withdrawBid);
        return txHash;
    }
}
exports.CandyShopAuction = CandyShopAuction;
